import { initializeIcons } from "@fluentui/font-icons-mdl2";
import "core-js";
import { createBrowserHistory } from "history";
import "media-match/media.match";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider, connect } from "react-redux";
import { Navigate, RouterProvider, useLocation } from "react-router";
import { createBrowserRouter } from "react-router-dom";
import { routerActions } from "react-router-redux";
import Alert from "react-s-alert";
import { bindActionCreators } from "redux";
import { UpdateLocation } from "./actions/routing";
import * as UserActions from "./actions/user";
import { OverlayLoading } from "./components/common";
import BaseLayout from "./components/layouts/BaseLayout";
import {
    CommitteeMeetingAttendancePage,
    CommitteeMeetingAttendancesPage,
    CommitteeMeetingPage,
    CommitteeMeetingsPage,
    CommitteeMemberPage,
    CommitteeMemberRolePage,
    CommitteeMemberRolesPage,
    CommitteeMembersPage,
    CommitteePage,
    CommitteeRegularInviteePage,
    CommitteeRegularInviteesPage,
    CommitteesPage,
    CountriesPage,
    CountryPage,
    DashboardPage,
    DiscussionPage,
    DiscussionsPage,
    ErrorPage,
    FacilityAllianceMemberPage,
    FacilityAllianceMembersPage,
    FellowshipPage,
    FellowshipsPage,
    FormTemplateFileTypePage,
    FormTemplateFileTypesPage,
    FormTemplatePage,
    FormTemplatesPage,
    GeneralSettingsPage,
    GroupContractPage,
    GroupFinancePage,
    GroupItemTemplateCategoryPage,
    GroupItemTemplateCategorysPage,
    GroupItemTemplatePage,
    GroupItemTemplatesPage,
    GroupItemsPage,
    GroupNotesPage,
    GroupPage,
    GroupPersonnelPage,
    GroupPersonnelsPage,
    GroupSettingsPage,
    GroupTrialsPage,
    GroupsPage,
    HealthDistrictPage,
    HealthDistrictsPage,
    HrecPage,
    HrecsPage,
    InstitutionCodePage,
    InstitutionCodesPage,
    InstitutionCodingPage,
    InstitutionCodingsPage,
    InstitutionContractPage,
    InstitutionDepartmentContactEditPage,
    InstitutionDepartmentEditPage,
    InstitutionDepartmentPersonnelEditPage,
    InstitutionDepartmentsPage,
    InstitutionFinancePage,
    InstitutionItemTemplateCategoriesPage,
    InstitutionItemTemplateCategoryPage,
    InstitutionItemTemplatePage,
    InstitutionItemTemplatesPage,
    InstitutionItemsPage,
    InstitutionLaboratoriesPage,
    InstitutionLaboratoryPage,
    InstitutionNotesPage,
    InstitutionPage,
    InstitutionPersonnelPage,
    InstitutionPersonnelsPage,
    InstitutionProcedurePage,
    InstitutionProceduresPage,
    InstitutionSettingsPage,
    InstitutionTrialsPage,
    InstitutionTypePage,
    InstitutionTypesPage,
    InstitutionsPage,
    InterestPage,
    InterestsPage,
    ItemComponentPage,
    ItemComponentTypePage,
    ItemComponentTypesPage,
    ItemComponentsPage,
    KeyContactPage,
    KeyContactsPage,
    LabContractPage,
    LabDepartmentPage,
    LabDepartmentsPage,
    LabFinancePage,
    LabInstitutionPage,
    LabInstitutionsPage,
    LabPage,
    LabPersonnelPage,
    LabPersonnelsPage,
    LabsPage,
    MembershipTypePage,
    MembershipTypesPage,
    MonitoringDocumentPage,
    MonitoringDocumentsPage,
    MonitoringIssueDocumentPage,
    MonitoringIssueDocumentsPage,
    MonitoringIssuePage,
    MonitoringIssuesPage,
    MonitoringPage,
    MonitoringsPage,
    MyTrialsPage,
    NotePage,
    NoteTypePage,
    NoteTypesPage,
    OpenClinicaUserRolesPage,
    PersonnelActiveDirectoryPage,
    PersonnelByRolesPage,
    PersonnelNotesPage,
    PersonnelOCRolesPage,
    PersonnelPage,
    PersonnelPermissionsPage,
    PersonnelRolePage,
    PersonnelRolesPage,
    PersonnelTrainingCertificationPage,
    PersonnelsPage,
    ProfessionalDisciplinePage,
    ProfessionalDisciplinesPage,
    ProjectInvestigatorPage,
    ProjectItemImportPage,
    ProjectItemTemplateCategoryPage,
    ProjectItemTemplateCategorysPage,
    ProjectItemTemplatePage,
    ProjectItemTemplatesPage,
    ProjectItemsPage,
    ProjectPage,
    ProjectSettingsPage,
    ProjectsPage,
    QAEmailTemplatePage,
    QAEmailTemplatesPage,
    QaSettingsPage,
    ReportingTagCategoriesPage,
    ReportingTagCategoryPage,
    ReportingTagPage,
    ReportingTagsPage,
    RolePage,
    RolesPage,
    SalutationPage,
    SalutationsPage,
    SearchPage,
    SettingsPage,
    SiteLocationPage,
    SiteLocationsPage,
    StatePage,
    StatesPage,
    TaskTypePage,
    TaskTypesPage,
    TrackerMilestonePage,
    TrackerMilestonesPage,
    TrackerTypePage,
    TrackerTypesPage,
    TrialAccrualsPage,
    TrialDoiPage,
    TrialFinancePage,
    TrialGroupContractPage,
    TrialGroupContractsPage,
    TrialGroupFinancePage,
    TrialGroupItemTemplateCategoriesPage,
    TrialGroupItemTemplateCategoryPage,
    TrialGroupItemTemplatePage,
    TrialGroupItemTemplatesPage,
    TrialGroupItemsPage,
    TrialGroupLaboratoriesPage,
    TrialGroupLaboratoryContractPage,
    TrialGroupLaboratoryContractsPage,
    TrialGroupLaboratoryFinancePage,
    TrialGroupLaboratoryPage,
    TrialGroupLaboratoryPersonnelPage,
    TrialGroupLaboratoryPersonnelsPage,
    TrialGroupPage,
    TrialGroupPersonnelPage,
    TrialGroupPersonnelsPage,
    TrialGroupSettingsPage,
    TrialGroupsPage,
    TrialInstitutionContractPage,
    TrialInstitutionContractsPage,
    TrialInstitutionFinancePage,
    TrialInstitutionItemCustomViewDataEntryPage,
    TrialInstitutionItemCustomViewPage,
    TrialInstitutionItemCustomViewsPage,
    TrialInstitutionItemTemplateCategoriesPage,
    TrialInstitutionItemTemplateCategoryPage,
    TrialInstitutionItemTemplatePage,
    TrialInstitutionItemTemplatesPage,
    TrialInstitutionItemsPage,
    TrialInstitutionLaboratoriesPage,
    TrialInstitutionLaboratoryContractPage,
    TrialInstitutionLaboratoryContractsPage,
    TrialInstitutionLaboratoryFinancePage,
    TrialInstitutionLaboratoryPage,
    TrialInstitutionLaboratoryPersonnelPage,
    TrialInstitutionLaboratoryPersonnelsPage,
    TrialInstitutionNotesPage,
    TrialInstitutionPage,
    TrialInstitutionPersonnelPage,
    TrialInstitutionPersonnelsPage,
    TrialInstitutionSettingsPage,
    TrialInstitutionsPage,
    TrialItemImportPage,
    TrialItemPage,
    TrialItemTemplateCategoriesPage,
    TrialItemTemplateCategoryPage,
    TrialItemTemplatePage,
    TrialItemTemplatesPage,
    TrialItemUpdatePage,
    TrialItemsPage,
    TrialLaboratoriesPage,
    TrialNotesPage,
    TrialPage,
    TrialPersonnelPage,
    TrialPersonnelsPage,
    TrialSettingsPage,
    TrialTypePage,
    TrialTypesPage,
    TrialWebsitePage,
    TrialsPage
} from "./containers/index";
import ReduxContext from "./contexts/ReduxContext";
import * as Dtos from "./dtos/Tmd.dtos";
import { RequestState } from "./enumerations/RequestState";
import { rootEpic } from "./epics/";
import { AppSettings } from "./helpers/AppSettings";
import { AppRouteObject } from "./hooks/useChildRouteData";
import useDispatch from "./hooks/useDispatch";
import useSelector from "./hooks/useSelector";
import reducers, { ITmdState } from "./reducers/";
import { configureStore } from "./store/";

import "./styles/app.scss";

// Register icons and pull the fonts from the default SharePoint cdn.
initializeIcons();

const reducer = reducers;

export const browserHistory = createBrowserHistory();

export const store = configureStore(reducer, rootEpic, browserHistory);

const RouterState = () => {
    const location = useLocation();
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(UpdateLocation(location));
    }, [location, dispatch]);

    const user = useSelector((state) => state.user.data);

    if (
        !user.roles?.["Global"].includes("BctStaff") &&
        !user.roles?.["Global"].includes("Admin") &&
        location.pathname !== "/error/403"
    ) {
        return (
            <>
                <Navigate replace to="/error/403" />
                <OverlayLoading />
            </>
        );
    }

    return <BaseLayout />;
};

const routes: AppRouteObject[] = [
    {
        path: "/",
        element: (
            <>
                <RouterState />
            </>
        ),
        loader: () => ({
            helpPage: null
        }),
        children: [
            {
                index: true,
                element: <Navigate replace to="/dashboard" />,
                loader: () => ({
                    helpPage: null
                }) 
            },
            {
                path: "*",
                element: <Navigate replace to="/error/404" />,
                loader: () => ({
                    helpPage: null
                }) 
            },
            {
                path: "dashboard",
                element: <DashboardPage />,
                loader: () => ({
                    helpPage: Dtos.Page.Dashboard
                }) 
            },
            {
                path: "search",
                element: <SearchPage />,
                loader: () => ({
                    helpPage: Dtos.Page.Dashboard
                }) 
            },
            {
                path: "mytrials",
                element: <MyTrialsPage />,
                loader: () => ({
                    helpPage: Dtos.Page.MyTrials
                }) 
            },
            {
                path: "error",
                loader: () => ({
                    helpPage: null
                }),
                children: [
                    {
                        path: ":errorCode",
                        element: <ErrorPage />,
                        loader: () => ({
                            helpPage: Dtos.Page.Error
                        }) 
                    },
                ],
            },
            {
                path: "settings",
                loader: () => ({
                    helpPage: null
                }),
                children: [
                    {
                        index: true,
                        element: <SettingsPage />,
                        loader: () => ({
                            helpPage: Dtos.Page.Settings
                        }) 
                    },
                    {
                        path: "general",
                        loader: () => ({
                            helpPage: null
                        }), 
                        children: [
                            {
                                index: true,
                                element: <GeneralSettingsPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.GeneralSettings
                                }) 
                            },
                            {
                                path: "countries",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <CountriesPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.Countries
                                        }) 
                                    },
                                    {
                                        path: ":countryId",
                                        element: <CountryPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.Country
                                        }) 
                                    },
                                ],
                            },
                            {
                                path: "roles",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <RolesPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.Roles
                                        }) 
                                    },
                                    {
                                        path: ":roleId",
                                        element: <RolePage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.Role
                                        }) 
                                    },
                                ],
                            },
                            {
                                path: "states",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <StatesPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.States
                                        }) 
                                    },
                                    {
                                        path: ":stateId",
                                        element: <StatePage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.State
                                        }) 
                                    },
                                ],
                            },
                            {
                                path: "itemcomponenttypes",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <ItemComponentTypesPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.ItemComponentTypes
                                        }) 
                                    },
                                    {
                                        path: ":itemcomponenttypesId",
                                        element: <ItemComponentTypePage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.ItemComponentType
                                        }) 
                                    },
                                ],
                            },
                            {
                                path: "notetypes",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <NoteTypesPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.NoteTypes
                                        }) 
                                    },
                                    {
                                        path: ":notetypesId",
                                        element: <NoteTypePage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.NoteType
                                        }) 
                                    },
                                ],
                            },
                            {
                                path: "interests",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <InterestsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.Interests
                                        }) 
                                    },
                                    {
                                        path: ":interestId",
                                        element: <InterestPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.Interest
                                        }) 
                                    },
                                ],
                            },
                            {
                                path: "membershiptypes",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <MembershipTypesPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.MembershipTypes
                                        }) 
                                    },
                                    {
                                        path: ":membershiptypesId",
                                        element: <MembershipTypePage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.MembershipType
                                        }) 
                                    },
                                ],
                            },
                            {
                                path: "professionaldisciplines",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: (
                                            <ProfessionalDisciplinesPage />
                                        ),
                                        loader: () => ({
                                            helpPage: Dtos.Page.ProfessionalDisciplines
                                        }) 
                                    },
                                    {
                                        path: ":professionaldisciplinesId",
                                        element: <ProfessionalDisciplinePage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.ProfessionalDiscipline
                                        }) 
                                    },
                                ],
                            },
                            {
                                path: "salutations",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <SalutationsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.Salutations
                                        }) 
                                    },
                                    {
                                        path: ":salutationId",
                                        element: <SalutationPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.Salutation
                                        }) 
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: "project",
                        loader: () => ({
                            helpPage: null
                        }),
                        children: [
                            {
                                index: true,
                                element: <ProjectSettingsPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.ProjectSettings
                                }) 
                            },
                            {
                                path: "itemtemplates",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <ProjectItemTemplatesPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.ProjectItemTemplates
                                        }) 
                                    },
                                    {
                                        path: ":projectItemTemplateId",
                                        element: <ProjectItemTemplatePage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.ProjectItemTemplate
                                        }) 
                                    },
                                ],
                            },
                            {
                                path: "itemcomponents",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <ItemComponentsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.ItemComponents
                                        })
                                    },
                                    {
                                        path: ":itemComponentId",
                                        element: <ItemComponentPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.ItemComponent
                                        }),
                                        children: [
                                            {
                                                path: ":cloneId",
                                                element: <ItemComponentPage />,
                                                loader: () => ({
                                                    helpPage: Dtos.Page.ItemComponent
                                                })
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "itemCategories",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: (
                                            <ProjectItemTemplateCategorysPage />
                                        ),
                                        loader: () => ({
                                            helpPage: Dtos.Page.ProjectItemTemplateCategorys
                                        })
                                    },
                                    {
                                        path: ":projectItemTemplateCategoryId",
                                        element: (
                                            <ProjectItemTemplateCategoryPage />
                                        ),
                                        loader: () => ({
                                            helpPage: Dtos.Page.ProjectItemTemplateCategory
                                        })
                                    },
                                ],
                            },
                            {
                                path: "projectitemimport",
                                element: <ProjectItemImportPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.ProjectItemImport
                                })
                            },
                        ],
                    },
                    {
                        path: "trial",
                        loader: () => ({
                            helpPage: null
                        }),
                        children: [
                            {
                                index: true,
                                element: <TrialSettingsPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.TrialSettings
                                })
                            },
                            {
                                path: "itemtemplates",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <TrialItemTemplatesPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.TrialItemTemplates
                                        })
                                    },
                                    {
                                        path: ":trialId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <TrialItemTemplatesPage />
                                                ),
                                                loader: () => ({
                                                    helpPage: Dtos.Page.TrialItemTemplates
                                                })
                                            },
                                            {
                                                path: "template",
                                                loader: () => ({
                                                    helpPage: null
                                                }),
                                                children: [
                                                    {
                                                        path: ":trialItemTemplateId",
                                                        element: (
                                                            <TrialItemTemplatePage />
                                                        ),
                                                        loader: () => ({
                                                            helpPage: Dtos.Page.TrialItemTemplate
                                                        })
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        path: "template",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                path: ":trialItemTemplateId",
                                                element: (
                                                    <TrialItemTemplatePage />
                                                ),
                                                loader: () => ({
                                                    helpPage: Dtos.Page.TrialItemTemplate
                                                })
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "itemcomponents",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <ItemComponentsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.ItemComponents
                                        })
                                    },
                                    {
                                        path: ":itemComponentId",
                                        element: <ItemComponentPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.ItemComponent
                                        }),
                                        children: [
                                            {
                                                path: ":cloneId",
                                                element: <ItemComponentPage />,
                                                loader: () => ({
                                                    helpPage: Dtos.Page.ItemComponent
                                                })
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "itemtemplatecategories",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: (
                                            <TrialItemTemplateCategoriesPage />
                                        ),
                                        loader: () => ({
                                            helpPage: Dtos.Page.TrialItemTemplateCategories
                                        })
                                    },
                                    {
                                        path: ":trialItemTemplateCategoryId",
                                        element: (
                                            <TrialItemTemplateCategoryPage />
                                        ),
                                        loader: () => ({
                                            helpPage: Dtos.Page.TrialItemTemplateCategory
                                        })
                                    },
                                ],
                            },
                            {
                                path: "trialtypes",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <TrialTypesPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.TrialTypes
                                        })
                                    },
                                    {
                                        path: ":trialTypeId",
                                        element: <TrialTypePage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.TrialType
                                        })
                                    },
                                ],
                            },
                            {
                                path: "trialitemimport",
                                element: <TrialItemImportPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.TrialItemImport
                                })
                            },
                        ],
                    },
                    {
                        path: "trialinstitution",
                        loader: () => ({
                            helpPage: null
                        }),
                        children: [
                            {
                                index: true,
                                element: <TrialInstitutionSettingsPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.TrialInstitutionSettings
                                })
                            },
                            {
                                path: "itemtemplates",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: (
                                            <TrialInstitutionItemTemplatesPage />
                                        ),
                                        loader: () => ({
                                            helpPage: Dtos.Page.TrialInstitutionItemTemplates
                                        })
                                    },
                                    {
                                        path: ":trialId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <TrialInstitutionItemTemplatesPage />
                                                ),
                                                loader: () => ({
                                                    helpPage: Dtos.Page.TrialInstitutionItemTemplates
                                                })
                                            },
                                            {
                                                path: "template",
                                                loader: () => ({
                                                    helpPage: null
                                                }),
                                                children: [
                                                    {
                                                        path: ":trialInstitutionItemTemplateId",
                                                        element: (
                                                            <TrialInstitutionItemTemplatePage />
                                                        ),
                                                        loader: () => ({
                                                            helpPage: Dtos.Page.TrialInstitutionItemTemplate
                                                        })
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        path: "template",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                path: ":trialInstitutionItemTemplateId",
                                                element: (
                                                    <TrialInstitutionItemTemplatePage />
                                                ),
                                                loader: () => ({
                                                    helpPage: Dtos.Page.TrialInstitutionItemTemplate
                                                })
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "itemcomponents",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <ItemComponentsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.ItemComponents
                                        })
                                    },
                                    {
                                        path: ":itemComponentId",
                                        element: <ItemComponentPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.ItemComponent
                                        }),
                                        children: [
                                            {
                                                path: ":cloneId",
                                                element: <ItemComponentPage />,
                                                loader: () => ({
                                                    helpPage: Dtos.Page.ItemComponent
                                                })
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "itemtemplatecategories",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: (
                                            <TrialInstitutionItemTemplateCategoriesPage />
                                        ),
                                        loader: () => ({
                                            helpPage: Dtos.Page.TrialInstitutionItemTemplateCategories
                                        })
                                    },
                                    {
                                        path: ":trialInstitutionItemTemplateCategoryId",
                                        element: (
                                            <TrialInstitutionItemTemplateCategoryPage />
                                        ),
                                        loader: () => ({
                                            helpPage: Dtos.Page.TrialInstitutionItemTemplateCategory
                                        })
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: "trialgroup",
                        loader: () => ({
                            helpPage: null
                        }),
                        children: [
                            {
                                index: true,
                                element: <TrialGroupSettingsPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.TrialGroupSettings
                                })
                            },
                            {
                                path: "itemtemplates",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: (
                                            <TrialGroupItemTemplatesPage />
                                        ),
                                        loader: () => ({
                                            helpPage: Dtos.Page.TrialGroupItemTemplates
                                        })
                                    },
                                    {
                                        path: ":groupId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <TrialGroupItemTemplatesPage />
                                                ),
                                                loader: () => ({
                                                    helpPage: Dtos.Page.TrialGroupItemTemplates
                                                })
                                            },
                                            {
                                                path: "template",
                                                loader: () => ({
                                                    helpPage: null
                                                }),
                                                children: [
                                                    {
                                                        path: ":trialGroupItemTemplateId",
                                                        element: (
                                                            <TrialGroupItemTemplatePage />
                                                        ),
                                                        loader: () => ({
                                                            helpPage: Dtos.Page.TrialGroupItemTemplate
                                                        })
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        path: "template",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                path: ":trialGroupItemTemplateId",
                                                element: (
                                                    <TrialGroupItemTemplatePage />
                                                ),
                                                loader: () => ({
                                                    helpPage: Dtos.Page.TrialGroupItemTemplate
                                                })
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "itemcomponents",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <ItemComponentsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.ItemComponents
                                        })
                                    },
                                    {
                                        path: ":itemComponentId",
                                        element: <ItemComponentPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.ItemComponent
                                        }),
                                        children: [
                                            {
                                                path: ":cloneId",
                                                element: <ItemComponentPage />,
                                                loader: () => ({
                                                    helpPage: Dtos.Page.ItemComponent
                                                })
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "itemtemplatecategories",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: (
                                            <TrialGroupItemTemplateCategoriesPage />
                                        ),
                                        loader: () => ({
                                            helpPage: Dtos.Page.TrialGroupItemTemplateCategories
                                        })
                                    },
                                    {
                                        path: ":trialGroupItemTemplateCategoryId",
                                        element: (
                                            <TrialGroupItemTemplateCategoryPage />
                                        ),
                                        loader: () => ({
                                            helpPage: Dtos.Page.TrialGroupItemTemplateCategory
                                        })
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: "group",
                        loader: () => ({
                            helpPage: null
                        }),
                        children: [
                            {
                                index: true,
                                element: <GroupSettingsPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.GroupSettings
                                }),
                            },
                            {
                                path: "itemtemplates",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <GroupItemTemplatesPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.GroupItemTemplates
                                        })
                                    },
                                    {
                                        path: ":groupId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <GroupItemTemplatesPage />
                                                ),
                                                loader: () => ({
                                                    helpPage: Dtos.Page.GroupItemTemplates
                                                })
                                            },
                                            {
                                                path: "template",
                                                loader: () => ({
                                                    helpPage: null
                                                }),
                                                children: [
                                                    {
                                                        path: ":groupItemTemplateId",
                                                        element: (
                                                            <GroupItemTemplatePage />
                                                        ),
                                                        loader: () => ({
                                                            helpPage: Dtos.Page.GroupItemTemplate
                                                        })
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        path: "template",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                path: ":groupItemTemplateId",
                                                element: (
                                                    <GroupItemTemplatePage />
                                                ),
                                                loader: () => ({
                                                    helpPage: Dtos.Page.GroupItemTemplate
                                                })
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "itemcomponents",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <ItemComponentsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.ItemComponents
                                        })
                                    },
                                    {
                                        path: ":itemComponentId",
                                        element: <ItemComponentPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.ItemComponent
                                        }),
                                        children: [
                                            {
                                                path: ":cloneId",
                                                element: <ItemComponentPage />,
                                                loader: () => ({
                                                    helpPage: Dtos.Page.ItemComponent
                                                })
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "itemCategories",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: (
                                            <GroupItemTemplateCategorysPage />
                                        ),
                                        loader: () => ({
                                            helpPage: Dtos.Page.GroupItemTemplateCategorys
                                        })
                                    },
                                    {
                                        path: ":groupItemTemplateCategoryId",
                                        element: (
                                            <GroupItemTemplateCategoryPage />
                                        ),
                                        loader: () => ({
                                            helpPage: Dtos.Page.GroupItemTemplateCategory
                                        })
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: "institution",
                        loader: () => ({
                            helpPage: null
                        }),
                        children: [
                            {
                                index: true,
                                element: <InstitutionSettingsPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.InstitutionSettings
                                })
                            },
                            {
                                path: "itemtemplates",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: (
                                            <InstitutionItemTemplatesPage />
                                        ),
                                        loader: () => ({
                                            helpPage: Dtos.Page.InstitutionItemTemplates
                                        })
                                    },
                                    {
                                        path: ":institutionId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <InstitutionItemTemplatesPage />
                                                ),
                                                loader: () => ({
                                                    helpPage: Dtos.Page.InstitutionItemTemplates
                                                })
                                            },
                                            {
                                                path: "template",
                                                loader: () => ({
                                                    helpPage: null
                                                }),
                                                children: [
                                                    {
                                                        path: ":institutionItemTemplateId",
                                                        element: (
                                                            <InstitutionItemTemplatePage />
                                                        ),
                                                        loader: () => ({
                                                            helpPage: Dtos.Page.InstitutionItemTemplate
                                                        })
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        path: "template",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                path: ":institutionItemTemplateId",
                                                element: (
                                                    <InstitutionItemTemplatePage />
                                                ),
                                                loader: () => ({
                                                    helpPage: Dtos.Page.InstitutionItemTemplate
                                                })
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "itemcomponents",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <ItemComponentsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.ItemComponents
                                        })
                                    },
                                    {
                                        path: ":itemComponentId",
                                        element: <ItemComponentPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.ItemComponent
                                        }),
                                        children: [
                                            {
                                                path: ":cloneId",
                                                element: <ItemComponentPage />,
                                                loader: () => ({
                                                    helpPage: Dtos.Page.ItemComponent
                                                })
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "itemtemplatecategories",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: (
                                            <InstitutionItemTemplateCategoriesPage />
                                        ),
                                        loader: () => ({
                                            helpPage: Dtos.Page.InstitutionItemTemplateCategories
                                        })
                                    },
                                    {
                                        path: ":institutionItemTemplateId",
                                        element: (
                                            <InstitutionItemTemplateCategoryPage />
                                        ),
                                        loader: () => ({
                                            helpPage: Dtos.Page.InstitutionItemTemplateCategory
                                        })
                                    },
                                ],
                            },
                            {
                                path: "sitelocations",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <SiteLocationsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.SiteLocations
                                        })
                                    },
                                    {
                                        path: ":siteLocationId",
                                        element: <SiteLocationPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.SiteLocation
                                        })
                                    },
                                ],
                            },
                            {
                                path: "keycontacts",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <KeyContactsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.KeyContacts
                                        })
                                    },
                                    {
                                        path: ":keyContactId",
                                        element: <KeyContactPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.KeyContact
                                        })
                                    },
                                ],
                            },
                            {
                                path: "facilityalliancemembers",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: (
                                            <FacilityAllianceMembersPage />
                                        ),
                                        loader: () => ({
                                            helpPage: Dtos.Page.FacilityAllianceMembers
                                        })
                                    },
                                    {
                                        path: ":facilityAllianceMemberId",
                                        element: <FacilityAllianceMemberPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.FacilityAllianceMember
                                        })
                                    },
                                ],
                            },
                            {
                                path: "institutiontypes",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <InstitutionTypesPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.InstitutionTypes
                                        })
                                    },
                                    {
                                        path: ":institutionTypeId",
                                        element: <InstitutionTypePage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.InstitutionType
                                        })
                                    },
                                ],
                            },
                            {
                                path: "institutioncodings",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <InstitutionCodingsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.InstitutionCodings
                                        })
                                    },
                                    {
                                        path: ":institutionCodingId",
                                        element: <InstitutionCodingPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.InstitutionCoding
                                        })
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: "qa",
                        loader: () => ({
                            helpPage: null
                        }),
                        children: [
                            {
                                index: true,
                                element: <QaSettingsPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.QaSettings
                                })
                            },
                            {
                                path: "formtemplates",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <FormTemplatesPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.FormTemplates
                                        })
                                    },
                                    {
                                        path: ":formTemplateId",
                                        element: <FormTemplatePage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.FormTemplate
                                        })
                                    },
                                ],
                            },
                            {
                                path: "formcomponents",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <ItemComponentsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.ItemComponents
                                        })
                                    },
                                    {
                                        path: ":itemComponentId",
                                        element: <ItemComponentPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.ItemComponent
                                        }),
                                        children: [
                                            {
                                                path: ":cloneId",
                                                element: <ItemComponentPage />,
                                                loader: () => ({
                                                    helpPage: Dtos.Page.ItemComponent
                                                })
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "reportingtags",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <ReportingTagsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.ReportingTags
                                        })
                                    },
                                    {
                                        path: ":reportingTagId",
                                        element: <ReportingTagPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.ReportingTag
                                        })
                                    },
                                ],
                            },
                            {
                                path: "reportingtagcategories",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <ReportingTagCategoriesPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.ReportingTagCategories
                                        })
                                    },
                                    {
                                        path: ":reportingTagCategoryId",
                                        element: <ReportingTagCategoryPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.ReportingTagCategory
                                        })
                                    },
                                ],
                            },
                            {
                                path: "tasktypes",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <TaskTypesPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.TaskTypes
                                        })
                                    },
                                    {
                                        path: ":taskTypeId",
                                        element: <TaskTypePage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.TaskType
                                        })
                                    },
                                ],
                            },
                            {
                                path: "trackertypes",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <TrackerTypesPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.TrackerTypes
                                        })
                                    },
                                    {
                                        path: ":trackerTypeId",
                                        element: <TrackerTypePage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.TrackerType
                                        })
                                    },
                                ],
                            },
                            {
                                path: "trackermilestones",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <TrackerMilestonesPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.TrackerMilestones
                                        })
                                    },
                                    {
                                        path: ":trackerMilestoneId",
                                        element: <TrackerMilestonePage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.TrackerMilestone
                                        })
                                    },
                                ],
                            },
                            {
                                path: "formtemplatefiletypes",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <FormTemplateFileTypesPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.FormTemplateFileTypes
                                        })
                                    },
                                    {
                                        path: ":formTemplateFileTypeId",
                                        element: <FormTemplateFileTypePage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.FormTemplateFileType
                                        })
                                    },
                                ],
                            },
                            {
                                path: "qaemailtemplates",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <QAEmailTemplatesPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.QAEmailTemplates
                                        })
                                    },
                                    {
                                        path: ":standardEmailTemplateId",
                                        element: <QAEmailTemplatePage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.QAEmailTemplate
                                        })
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: "openclinicauserroles",
                        loader: () => ({
                            helpPage: null
                        }),
                        children: [
                            {
                                index: true,
                                element: <OpenClinicaUserRolesPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.OpenClinicaUserRoles
                                })
                            },
                        ],
                    },
                    {
                        path: "hrecs",
                        loader: () => ({
                            helpPage: null
                        }),
                        children: [
                            {
                                index: true,
                                element: <HrecsPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.Hrecs
                                })
                            },
                            {
                                path: "create",
                                element: <HrecPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.Hrec
                                })
                            },
                            {
                                path: ":hrecId",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: (
                                            <Navigate replace to="details" />
                                        ),
                                        loader: () => ({
                                            helpPage: null
                                        }) 
                                    },
                                    {
                                        path: "details",
                                        element: <HrecPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.Hrec
                                        })
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: "healthdistricts",
                        loader: () => ({
                            helpPage: null
                        }),
                        children: [
                            {
                                index: true,
                                element: <HealthDistrictsPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.HealthDistricts
                                })
                            },
                            {
                                path: "create",
                                element: <HealthDistrictPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.HealthDistrict
                                })
                            },
                            {
                                path: ":healthDistrictId",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: (
                                            <Navigate replace to="details" />
                                        ),
                                        loader: () => ({
                                            helpPage: null
                                        }) 
                                    },
                                    {
                                        path: "details",
                                        element: <HealthDistrictPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.HealthDistrict
                                        })
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                path: "trials",
                loader: () => ({
                    helpPage: null
                }),
                children: [
                    {
                        index: true,
                        element: <TrialsPage />,
                        loader: () => ({
                            helpPage: Dtos.Page.Trials
                        })
                    },
                    {
                        path: "create",
                        element: <TrialPage />,
                        loader: () => ({
                            helpPage: Dtos.Page.Trial
                        })
                    },
                    {
                        path: ":trialId",
                        loader: () => ({
                            helpPage: null
                        }),
                        children: [
                            {
                                index: true,
                                element: <Navigate replace to="details" />,
                                loader: () => ({
                                    helpPage: null
                                }) 
                            },
                            {
                                path: "details",
                                element: <TrialPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.Trial
                                })
                            },
                            {
                                path: "institutions",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <TrialInstitutionsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.TrialInstitutions
                                        })
                                    },
                                ],
                            },
                            {
                                path: "trialinstitution",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        path: ":trialInstitutionId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <Navigate replace to="details" />
                                                ),
                                                loader: () => ({
                                                    helpPage: null
                                                }) 
                                            },
                                            {
                                                path: "details",
                                                element: (
                                                    <TrialInstitutionPage />
                                                ),
                                                loader: () => ({
                                                    helpPage: Dtos.Page.TrialInstitution
                                                })
                                            },
                                            {
                                                path: "items",
                                                element: (
                                                    <TrialInstitutionItemsPage />
                                                ),
                                                loader: () => ({
                                                    helpPage: Dtos.Page.TrialInstitutionItems
                                                })
                                            },
                                            {
                                                path: "personnel",
                                                loader: () => ({
                                                    helpPage: null
                                                }),
                                                children: [
                                                    {
                                                        index: true,
                                                        element: (
                                                            <TrialInstitutionPersonnelsPage />
                                                        ),
                                                        loader: () => ({
                                                            helpPage: Dtos.Page.TrialInstitutionPersonnels
                                                        })
                                                    },
                                                    {
                                                        path: "create",
                                                        element: (
                                                            <TrialInstitutionPersonnelPage />
                                                        ),
                                                        loader: () => ({
                                                            helpPage: Dtos.Page.TrialInstitutionPersonnel
                                                        })
                                                    },
                                                    {
                                                        path: ":personnelId",
                                                        loader: () => ({
                                                            helpPage: null
                                                        }),
                                                        children: [
                                                            {
                                                                index: true,
                                                                element: (
                                                                    <Navigate replace to="details" />
                                                                ),
                                                                loader: () => ({
                                                                    helpPage: null
                                                                }) 
                                                            },
                                                            {
                                                                path: "details",
                                                                element: (
                                                                    <TrialInstitutionPersonnelPage />
                                                                ),
                                                                loader: () => ({
                                                                    helpPage: Dtos.Page.TrialInstitutionPersonnel
                                                                })
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            {
                                                path: "notes",
                                                loader: () => ({
                                                    helpPage: null
                                                }),
                                                children: [
                                                    {
                                                        index: true,
                                                        element: (
                                                            <TrialInstitutionNotesPage />
                                                        ),
                                                        loader: () => ({
                                                            helpPage: Dtos.Page.TrialInstitutionNotes
                                                        })
                                                    },
                                                    {
                                                        path: "create",
                                                        element: <NotePage />,
                                                        loader: () => ({
                                                            helpPage: Dtos.Page.Note
                                                        })
                                                    },
                                                    {
                                                        path: ":noteId",
                                                        loader: () => ({
                                                            helpPage: null
                                                        }),
                                                        children: [
                                                            {
                                                                index: true,
                                                                element: (
                                                                    <Navigate replace to="details" />
                                                                ),
                                                                loader: () => ({
                                                                    helpPage: null
                                                                }) 
                                                            },
                                                            {
                                                                path: "details",
                                                                element: (
                                                                    <NotePage />
                                                                ),
                                                                loader: () => ({
                                                                    helpPage: Dtos.Page.Note
                                                                })
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            {
                                                path: "labs",
                                                loader: () => ({
                                                    helpPage: null
                                                }),
                                                children: [
                                                    {
                                                        index: true,
                                                        element: (
                                                            <TrialInstitutionLaboratoriesPage />
                                                        ),
                                                        loader: () => ({
                                                            helpPage: Dtos.Page.TrialInstitutionLaboratories
                                                        })
                                                    },
                                                    {
                                                        path: "create",
                                                        element: (
                                                            <TrialInstitutionLaboratoryPage />
                                                        ),
                                                        loader: () => ({
                                                            helpPage: Dtos.Page.TrialInstitutionLaboratory
                                                        })
                                                    },
                                                    {
                                                        path: ":trialInstitutionLaboratoryId",
                                                        loader: () => ({
                                                            helpPage: null
                                                        }),
                                                        children: [
                                                            {
                                                                index: true,
                                                                element: (
                                                                    <Navigate replace to="details" />
                                                                ),
                                                                loader: () => ({
                                                                    helpPage: null
                                                                }) 
                                                            },
                                                            {
                                                                path: "details",
                                                                element: (
                                                                    <TrialInstitutionLaboratoryPage />
                                                                ),
                                                                loader: () => ({
                                                                    helpPage: Dtos.Page.TrialInstitutionLaboratory
                                                                })
                                                            },
                                                            {
                                                                path: "personnel",
                                                                loader: () => ({
                                                                    helpPage: null
                                                                }),
                                                                children: [
                                                                    {
                                                                        index: true,
                                                                        element:
                                                                            (
                                                                                <TrialInstitutionLaboratoryPersonnelsPage />
                                                                            ),
                                                                            loader: () => ({
                                                                                helpPage: Dtos.Page.TrialInstitutionLaboratoryPersonnels
                                                                            })
                                                                    },
                                                                    {
                                                                        path: "create",
                                                                        element:
                                                                            (
                                                                                <TrialInstitutionLaboratoryPersonnelPage />
                                                                            ),
                                                                            loader: () => ({
                                                                                helpPage: Dtos.Page.TrialInstitutionLaboratoryPersonnel
                                                                            })
                                                                    },
                                                                    {
                                                                        path: ":trialInstitutionLaboratoryPersonnelId",
                                                                        loader: () => ({
                                                                            helpPage: null
                                                                        }),
                                                                        children:
                                                                            [
                                                                                {
                                                                                    index: true,
                                                                                    element:
                                                                                        (
                                                                                            <Navigate replace to="details" />
                                                                                        ),
                                                                                        loader: () => ({
                                                                                            helpPage: null
                                                                                        }) 
                                                                                },
                                                                                {
                                                                                    path: "details",
                                                                                    element:
                                                                                        (
                                                                                            <TrialInstitutionLaboratoryPersonnelPage />
                                                                                        ),
                                                                                        loader: () => ({
                                                                                            helpPage: Dtos.Page.TrialInstitutionLaboratoryPersonnel
                                                                                        })
                                                                                },
                                                                            ],
                                                                    },
                                                                ],
                                                            },
                                                            {
                                                                path: "finance",
                                                                element: (
                                                                    <TrialInstitutionLaboratoryFinancePage />
                                                                ),
                                                                loader: () => ({
                                                                    helpPage: Dtos.Page.TrialInstitutionLaboratoryFinance
                                                                })
                                                            },
                                                            {
                                                                path: "contracts",
                                                                loader: () => ({
                                                                    helpPage: null
                                                                }),
                                                                children: [
                                                                    {
                                                                        index: true,
                                                                        element:
                                                                            (
                                                                                <TrialInstitutionLaboratoryContractsPage />
                                                                            ),
                                                                            loader: () => ({
                                                                                helpPage: Dtos.Page.TrialInstitutionLaboratoryContracts
                                                                            })
                                                                    },
                                                                    {
                                                                        path: "create",
                                                                        element:
                                                                            (
                                                                                <TrialInstitutionLaboratoryContractPage />
                                                                            ),
                                                                            loader: () => ({
                                                                                helpPage: Dtos.Page.TrialInstitutionLaboratoryContract
                                                                            })
                                                                    },
                                                                    {
                                                                        path: ":trialInstitutionLaboratoryContractId",
                                                                        loader: () => ({
                                                                            helpPage: null
                                                                        }),
                                                                        children:
                                                                            [
                                                                                {
                                                                                    index: true,
                                                                                    element:
                                                                                        (
                                                                                            <Navigate replace to="details" />
                                                                                        ),
                                                                                        loader: () => ({
                                                                                            helpPage: null
                                                                                        }) 
                                                                                },
                                                                                {
                                                                                    path: "details",
                                                                                    element:
                                                                                        (
                                                                                            <TrialInstitutionLaboratoryContractPage />
                                                                                        ),
                                                                                        loader: () => ({
                                                                                            helpPage: Dtos.Page.TrialInstitutionLaboratoryContract
                                                                                        })
                                                                                },
                                                                            ],
                                                                    },
                                                                ],
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            {
                                                path: "finance",
                                                element: (
                                                    <TrialInstitutionFinancePage />
                                                ),
                                                loader: () => ({
                                                    helpPage: Dtos.Page.TrialInstitutionFinance
                                                })
                                            },
                                            {
                                                path: "contracts",
                                                loader: () => ({
                                                    helpPage: null
                                                }),
                                                children: [
                                                    {
                                                        index: true,
                                                        element: (
                                                            <TrialInstitutionContractsPage />
                                                        ),
                                                        loader: () => ({
                                                            helpPage: Dtos.Page.TrialInstitutionContracts
                                                        })
                                                    },
                                                    {
                                                        path: "create",
                                                        element: (
                                                            <TrialInstitutionContractPage />
                                                        ),
                                                        loader: () => ({
                                                            helpPage: Dtos.Page.TrialInstitutionContract
                                                        })
                                                    },
                                                    {
                                                        path: ":trialInstitutionContractId",
                                                        loader: () => ({
                                                            helpPage: null
                                                        }),
                                                        children: [
                                                            {
                                                                index: true,
                                                                element: (
                                                                    <Navigate replace to="details" />
                                                                ),
                                                                loader: () => ({
                                                                    helpPage: null
                                                                }) 
                                                            },
                                                            {
                                                                path: "details",
                                                                element: (
                                                                    <TrialInstitutionContractPage />
                                                                ),
                                                                loader: () => ({
                                                                    helpPage: Dtos.Page.TrialInstitutionContract
                                                                })
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            {
                                                path: "monitoring",
                                                loader: () => ({
                                                    helpPage: null
                                                }),
                                                children: [
                                                    {
                                                        index: true,
                                                        element: (
                                                            <MonitoringsPage />
                                                        ),
                                                        loader: () => ({
                                                            helpPage: Dtos.Page.Monitorings
                                                        })
                                                    },
                                                    {
                                                        path: "create",
                                                        element: (
                                                            <MonitoringPage />
                                                        ),
                                                        loader: () => ({
                                                            helpPage: Dtos.Page.Monitoring
                                                        })
                                                    },
                                                    {
                                                        path: ":monitoringId",
                                                        loader: () => ({
                                                            helpPage: null
                                                        }),
                                                        children: [
                                                            {
                                                                index: true,
                                                                element: (
                                                                    <Navigate replace to="details" />
                                                                ),
                                                                loader: () => ({
                                                                    helpPage: null
                                                                }) 
                                                            },
                                                            {
                                                                path: "details",
                                                                element: (
                                                                    <MonitoringPage />
                                                                ),
                                                                loader: () => ({
                                                                    helpPage: Dtos.Page.Monitoring
                                                                })
                                                            },
                                                            {
                                                                path: "documents",
                                                                loader: () => ({
                                                                    helpPage: null
                                                                }),
                                                                children: [
                                                                    {
                                                                        index: true,
                                                                        element: (
                                                                            <MonitoringDocumentsPage />
                                                                        ),
                                                                        loader: () => ({
                                                                            helpPage: Dtos.Page.MonitoringDocuments
                                                                        })                                                                        
                                                                    },
                                                                    {
                                                                        path: "create",
                                                                        element: (
                                                                            <MonitoringDocumentPage />
                                                                        ),
                                                                        loader: () => ({
                                                                            helpPage: Dtos.Page.MonitoringDocument
                                                                        })
                                                                    },
                                                                    {
                                                                        path: ":monitoringDocumentId",
                                                                        loader: () => ({
                                                                            helpPage: null
                                                                        }),
                                                                        children: [
                                                                            {
                                                                                index: true,
                                                                                element: (
                                                                                    <Navigate replace to="details" />
                                                                                ),
                                                                                loader: () => ({
                                                                                    helpPage: null
                                                                                }) 
                                                                            },
                                                                            {
                                                                                path: "details",
                                                                                element: (
                                                                                    <MonitoringDocumentPage />
                                                                                ),
                                                                                loader: () => ({
                                                                                    helpPage: Dtos.Page.MonitoringDocument
                                                                                })
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                path: "issues",
                                                                loader: () => ({
                                                                    helpPage: Dtos.Page.Monitorings
                                                                }),
                                                                children: [
                                                                    {
                                                                        index: true,
                                                                        element: (
                                                                            <MonitoringIssuesPage />
                                                                        ),
                                                                        loader: () => ({
                                                                            helpPage: Dtos.Page.MonitoringIssues
                                                                        })                                                                    
                                                                    },
                                                                    {
                                                                        path: "create",
                                                                        element: (
                                                                            <MonitoringIssuePage />
                                                                        ),
                                                                        loader: () => ({
                                                                            helpPage: Dtos.Page.MonitoringIssue
                                                                        })
                                                                    },
                                                                    {
                                                                        path: ":monitoringIssueId",
                                                                        loader: () => ({
                                                                            helpPage: null
                                                                        }),
                                                                        children: [
                                                                            {
                                                                                index: true,
                                                                                element: (
                                                                                    <Navigate replace to="details" />
                                                                                ),
                                                                                loader: () => ({
                                                                                    helpPage: null
                                                                                }) 
                                                                            },
                                                                            {
                                                                                path: "details",
                                                                                element: (
                                                                                    <MonitoringIssuePage />
                                                                                ),
                                                                                loader: () => ({
                                                                                    helpPage: Dtos.Page.MonitoringIssue
                                                                                })
                                                                            },
                                                                            {
                                                                                path: "documents",
                                                                                loader: () => ({
                                                                                    helpPage: null
                                                                                }),
                                                                                children: [
                                                                                    {
                                                                                        index: true,
                                                                                        element: (
                                                                                            <MonitoringIssueDocumentsPage />
                                                                                        ),
                                                                                        loader: () => ({
                                                                                            helpPage: Dtos.Page.MonitoringIssueDocuments
                                                                                        })                                                                       
                                                                                    },
                                                                                    {
                                                                                        path: "create",
                                                                                        element: (
                                                                                            <MonitoringIssueDocumentPage />
                                                                                        ),
                                                                                        loader: () => ({
                                                                                            helpPage: Dtos.Page.MonitoringIssueDocument
                                                                                        })
                                                                                    },
                                                                                    {
                                                                                        path: ":monitoringIssueDocumentId",
                                                                                        loader: () => ({
                                                                                            helpPage: null
                                                                                        }),
                                                                                        children: [
                                                                                            {
                                                                                                index: true,
                                                                                                element: (
                                                                                                    <Navigate replace to="details" />
                                                                                                ),
                                                                                                loader: () => ({
                                                                                                    helpPage: null
                                                                                                }) 
                                                                                            },
                                                                                            {
                                                                                                path: "details",
                                                                                                element: (
                                                                                                    <MonitoringIssueDocumentPage />
                                                                                                ),
                                                                                                loader: () => ({
                                                                                                    helpPage: Dtos.Page.MonitoringIssueDocument
                                                                                                })
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "trialinstitutionitemviews",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: (
                                            <TrialInstitutionItemCustomViewsPage />
                                        ),
                                        loader: () => ({
                                            helpPage: Dtos.Page.TrialInstitutionItemCustomViews
                                        }) 
                                    },
                                    {
                                        path: ":trialInstitutionItemCustomViewId/dataentry",
                                        element: (
                                            <TrialInstitutionItemCustomViewDataEntryPage />
                                        ),
                                        loader: () => ({
                                            helpPage: Dtos.Page.TrialInstitutionItemCustomViewDataEntry
                                        }) 
                                    },
                                    {
                                        path: ":trialInstitutionItemCustomViewId",
                                        element: (
                                            <TrialInstitutionItemCustomViewPage />
                                        ),
                                        loader: () => ({
                                            helpPage: Dtos.Page.TrialInstitutionItemCustomView
                                        }) 
                                    },
                                ],
                            },
                            {
                                path: "trialitems",
                                loader: () => ({
                                    helpPage: Dtos.Page.Dashboard
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <TrialItemsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.TrialItems
                                        }) 
                                    },
                                    {
                                        path: ":trialItemId",
                                        element: <TrialItemPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.TrialItem
                                        }) 
                                    },
                                ],
                            },
                            {
                                path: "personnel",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <TrialPersonnelsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.TrialPersonnel
                                        }) 
                                    },
                                    {
                                        path: "create",
                                        element: <TrialPersonnelPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.TrialPersonnel
                                        }) 
                                    },
                                    {
                                        path: ":trialPersonnelId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <Navigate replace to="details" />
                                                ),
                                                loader: () => ({
                                                    helpPage: null
                                                }) 
                                            },
                                            {
                                                path: "details",
                                                element: <TrialPersonnelPage />,
                                                loader: () => ({
                                                    helpPage: Dtos.Page.TrialPersonnel
                                                }) 
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "accrual",
                                element: <TrialAccrualsPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.TrialAccruals
                                }) 
                            },
                            {
                                path: "notes",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <TrialNotesPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.TrialNotes
                                        }) 
                                    },
                                    {
                                        path: "create",
                                        element: <NotePage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.Note
                                        }) 
                                    },
                                    {
                                        path: ":noteId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <Navigate replace to="details" />
                                                ),
                                                loader: () => ({
                                                    helpPage: null
                                                }) 
                                            },
                                            {
                                                path: "details",
                                                element: <NotePage />,
                                                loader: () => ({
                                                    helpPage: Dtos.Page.Note
                                                }) 
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "groups",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <TrialGroupsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.TrialGroups
                                        }) 
                                    },
                                    {
                                        path: ":groupId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                path: "trialgroup",
                                                loader: () => ({
                                                    helpPage: null
                                                }),
                                                children: [
                                                    {
                                                        path: ":trialGroupId",
                                                        loader: () => ({
                                                            helpPage: Dtos.Page.Dashboard
                                                        }),
                                                        children: [
                                                            {
                                                                index: true,
                                                                element: (
                                                                    <Navigate replace to="details" />
                                                                ),
                                                                loader: () => ({
                                                                    helpPage: null
                                                                }) 
                                                            },
                                                            {
                                                                path: "details",
                                                                element: (
                                                                    <TrialGroupPage />
                                                                ),
                                                                loader: () => ({
                                                                    helpPage: Dtos.Page.TrialGroup
                                                                }) 
                                                            },
                                                            {
                                                                path: "personnel",
                                                                loader: () => ({
                                                                    helpPage: null
                                                                }),
                                                                children: [
                                                                    {
                                                                        index: true,
                                                                        element:
                                                                            (
                                                                                <TrialGroupPersonnelsPage />
                                                                            ),
                                                                            loader: () => ({
                                                                                helpPage: Dtos.Page.TrialGroupPersonnels
                                                                            }) 
                                                                    },
                                                                    {
                                                                        path: "create",
                                                                        element:
                                                                            (
                                                                                <TrialGroupPersonnelPage />
                                                                            ),
                                                                        loader: () => ({
                                                                            helpPage: Dtos.Page.TrialGroupPersonnel
                                                                        }) 
                                                                    },
                                                                    {
                                                                        path: ":trialPersonnelId",
                                                                        loader: () => ({
                                                                            helpPage: null
                                                                        }),
                                                                        children:
                                                                            [
                                                                                {
                                                                                    index: true,
                                                                                    element:
                                                                                        (
                                                                                            <Navigate replace to="details" />
                                                                                        ),
                                                                                        loader: () => ({
                                                                                            helpPage: null
                                                                                        }) 
                                                                                },
                                                                                {
                                                                                    path: "details",
                                                                                    element:
                                                                                        (
                                                                                            <TrialGroupPersonnelPage />
                                                                                        ),
                                                                                    loader: () => ({
                                                                                        helpPage: Dtos.Page.TrialGroupPersonnel
                                                                                    }) 
                                                                                },
                                                                            ],
                                                                    },
                                                                ],
                                                            },
                                                            {
                                                                path: "items",
                                                                element: (
                                                                    <TrialGroupItemsPage />
                                                                ),
                                                                loader: () => ({
                                                                    helpPage: Dtos.Page.TrialGroupItems
                                                                }) 
                                                            },
                                                            {
                                                                path: "labs",
                                                                loader: () => ({
                                                                    helpPage: null
                                                                }),
                                                                children: [
                                                                    {
                                                                        index: true,
                                                                        element:
                                                                            (
                                                                                <TrialGroupLaboratoriesPage />
                                                                            ),
                                                                        loader: () => ({
                                                                            helpPage: Dtos.Page.TrialGroupLaboratories
                                                                        }) 
                                                                    },
                                                                    {
                                                                        path: "create",
                                                                        element:
                                                                            (
                                                                                <TrialGroupLaboratoryPage />
                                                                            ),
                                                                        loader: () => ({
                                                                            helpPage: Dtos.Page.TrialGroupLaboratory
                                                                        }) 
                                                                    },
                                                                    {
                                                                        path: ":trialGroupLaboratoryId",
                                                                        loader: () => ({
                                                                            helpPage: null
                                                                        }),
                                                                        children:
                                                                            [
                                                                                {
                                                                                    index: true,
                                                                                    element:
                                                                                        (
                                                                                            <Navigate replace to="details" />
                                                                                        ),
                                                                                        loader: () => ({
                                                                                            helpPage: null
                                                                                        }) 
                                                                                },
                                                                                {
                                                                                    path: "details",
                                                                                    element:
                                                                                        (
                                                                                            <TrialGroupLaboratoryPage />
                                                                                        ),
                                                                                    loader: () => ({
                                                                                        helpPage: Dtos.Page.TrialGroupLaboratory
                                                                                    }) 
                                                                                },
                                                                                {
                                                                                    path: "personnel",
                                                                                    loader: () => ({
                                                                                        helpPage: null
                                                                                    }),
                                                                                    children:
                                                                                        [
                                                                                            {
                                                                                                index: true,
                                                                                                element:
                                                                                                    (
                                                                                                        <TrialGroupLaboratoryPersonnelsPage />
                                                                                                    ),
                                                                                                loader: () => ({
                                                                                                    helpPage: Dtos.Page.TrialGroupLaboratoryPersonnels
                                                                                                }) 
                                                                                            },
                                                                                            {
                                                                                                path: "create",
                                                                                                element:
                                                                                                    (
                                                                                                        <TrialGroupLaboratoryPersonnelPage />
                                                                                                    ),
                                                                                                loader: () => ({
                                                                                                    helpPage: Dtos.Page.TrialGroupLaboratoryPersonnel
                                                                                                }) 
                                                                                            },
                                                                                            {
                                                                                                path: ":trialGroupLaboratoryPersonnelId",
                                                                                                loader: () => ({
                                                                                                    helpPage: null
                                                                                                }),
                                                                                                children:
                                                                                                    [
                                                                                                        {
                                                                                                            index: true,
                                                                                                            element:
                                                                                                                (
                                                                                                                    <Navigate replace to="details" />
                                                                                                                ),
                                                                                                                loader: () => ({
                                                                                                                    helpPage: null
                                                                                                                }) 
                                                                                                        },
                                                                                                        {
                                                                                                            path: "details",
                                                                                                            element:
                                                                                                                (
                                                                                                                    <TrialGroupLaboratoryPersonnelPage />
                                                                                                                ),
                                                                                                            loader: () => ({
                                                                                                                helpPage: Dtos.Page.TrialGroupLaboratoryPersonnel
                                                                                                            }) 
                                                                                                        },
                                                                                                    ],
                                                                                            },
                                                                                        ],
                                                                                },
                                                                                {
                                                                                    path: "finance",
                                                                                    element:
                                                                                        (
                                                                                            <TrialGroupLaboratoryFinancePage />
                                                                                        ),
                                                                                    loader: () => ({
                                                                                        helpPage: Dtos.Page.TrialGroupLaboratoryFinance
                                                                                    }) 
                                                                                },
                                                                                {
                                                                                    path: "contracts",
                                                                                    loader: () => ({
                                                                                        helpPage: null
                                                                                    }),
                                                                                    children:
                                                                                        [
                                                                                            {
                                                                                                index: true,
                                                                                                element:
                                                                                                    (
                                                                                                        <TrialGroupLaboratoryContractsPage />
                                                                                                    ),
                                                                                                loader: () => ({
                                                                                                    helpPage: Dtos.Page.TrialGroupLaboratoryContracts
                                                                                                }) 
                                                                                            },
                                                                                            {
                                                                                                path: "create",
                                                                                                element:
                                                                                                    (
                                                                                                        <TrialGroupLaboratoryContractPage />
                                                                                                    ),
                                                                                                loader: () => ({
                                                                                                    helpPage: Dtos.Page.TrialGroupLaboratoryContract
                                                                                                }) 
                                                                                            },
                                                                                            {
                                                                                                path: ":trialGroupLaboratoryContractId",
                                                                                                loader: () => ({
                                                                                                    helpPage: null
                                                                                                }),
                                                                                                children:
                                                                                                    [
                                                                                                        {
                                                                                                            index: true,
                                                                                                            element:
                                                                                                                (
                                                                                                                    <Navigate replace to="details" />
                                                                                                                ),
                                                                                                                loader: () => ({
                                                                                                                    helpPage: null
                                                                                                                }) 
                                                                                                        },
                                                                                                        {
                                                                                                            path: "details",
                                                                                                            element:
                                                                                                                (
                                                                                                                    <TrialGroupLaboratoryContractPage />
                                                                                                                ),
                                                                                                            loader: () => ({
                                                                                                                helpPage: Dtos.Page.TrialGroupLaboratoryContract
                                                                                                            }) 
                                                                                                        },
                                                                                                    ],
                                                                                            },
                                                                                        ],
                                                                                },
                                                                            ],
                                                                    },
                                                                ],
                                                            },
                                                            {
                                                                path: "finance",
                                                                element: (
                                                                    <TrialGroupFinancePage />
                                                                ),
                                                                loader: () => ({
                                                                    helpPage: Dtos.Page.TrialGroupFinance
                                                                }) 
                                                            },
                                                            {
                                                                path: "contracts",
                                                                loader: () => ({
                                                                    helpPage: null
                                                                }),
                                                                children: [
                                                                    {
                                                                        index: true,
                                                                        element:
                                                                            (
                                                                                <TrialGroupContractsPage />
                                                                            ),
                                                                        loader: () => ({
                                                                            helpPage: Dtos.Page.TrialGroupContracts
                                                                        }) 
                                                                    },
                                                                    {
                                                                        path: "create",
                                                                        element:
                                                                            (
                                                                                <TrialGroupContractPage />
                                                                            ),
                                                                        loader: () => ({
                                                                            helpPage: Dtos.Page.TrialGroupContract
                                                                        }) 
                                                                    },
                                                                    {
                                                                        path: ":trialGroupContractId",
                                                                        loader: () => ({
                                                                            helpPage: null
                                                                        }),
                                                                        children:
                                                                            [
                                                                                {
                                                                                    index: true,
                                                                                    element:
                                                                                        (
                                                                                            <Navigate replace to="details" />
                                                                                        ),
                                                                                        loader: () => ({
                                                                                            helpPage: null
                                                                                        }) 
                                                                                },
                                                                                {
                                                                                    path: "details",
                                                                                    element:
                                                                                        (
                                                                                            <TrialGroupContractPage />
                                                                                        ),
                                                                                    loader: () => ({
                                                                                        helpPage: Dtos.Page.TrialGroupContract
                                                                                    }) 
                                                                                },
                                                                            ],
                                                                    },
                                                                ],
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        path: ":trialGroupId",
                                        loader: () => ({
                                            helpPage: Dtos.Page.Dashboard
                                        }),
                                        children: [
                                            {
                                                path: "details",
                                                element: <TrialGroupPage />,
                                                loader: () => ({
                                                    helpPage: Dtos.Page.TrialGroup
                                                }) 
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "datasharing",
                                element: <TrialDoiPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.TrialDoi
                                }) 
                            },
                            {
                                path: "website",
                                element: <TrialWebsitePage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.TrialWebsite
                                }) 
                            },
                            {
                                path: "finance",
                                element: <TrialFinancePage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.TrialFinance
                                }) 
                            },
                            {
                                path: "trialitemupdate",
                                element: <TrialItemUpdatePage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.TrialItemUpdate
                                }) 
                            },
                            {
                                path: "labs",
                                element: <TrialLaboratoriesPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.TrialLaboratories
                                }) 
                            },
                        ],
                    },
                    {
                        path: ":projectId",
                        loader: () => ({
                            helpPage: null
                        }),
                        children: [
                            {
                                path: "project",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        path: "details",
                                        element: <ProjectPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.Project
                                        }) 
                                    },
                                    {
                                        path: "investigators",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                path: ":projectInvestigatorId",
                                                loader: () => ({
                                                    helpPage: null
                                                }),
                                                children: [
                                                    {
                                                        index: true,
                                                        element: (
                                                            <Navigate replace to="details" />
                                                        ),
                                                        loader: () => ({
                                                            helpPage: null
                                                        }) 
                                                    },
                                                    {
                                                        path: "details",
                                                        element: (
                                                            <ProjectInvestigatorPage />
                                                        ),
                                                        loader: () => ({
                                                            helpPage: Dtos.Page.ProjectInvestigator
                                                        }) 
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        path: "discussions",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: <DiscussionsPage />,
                                                loader: () => ({
                                                    helpPage: Dtos.Page.Discussions
                                                }) 
                                            },
                                            {
                                                path: "create",
                                                element: <DiscussionPage />,
                                                loader: () => ({
                                                    helpPage: Dtos.Page.Discussion
                                                }) 
                                            },
                                            {
                                                path: ":discussionId",
                                                loader: () => ({
                                                    helpPage: null
                                                }),
                                                children: [
                                                    {
                                                        index: true,
                                                        element: (
                                                            <Navigate replace to="details" />
                                                        ),
                                                        loader: () => ({
                                                            helpPage: null
                                                        }) 
                                                    },
                                                    {
                                                        path: "details",
                                                        element: (
                                                            <DiscussionPage />
                                                        ),
                                                        loader: () => ({
                                                            helpPage: Dtos.Page.Discussion
                                                        }) 
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        path: "items",
                                        element: <ProjectItemsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.ProjectItems
                                        }) 
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                path: "committees",
                loader: () => ({
                    helpPage: null
                }),
                children: [
                    {
                        index: true,
                        element: <CommitteesPage />,
                        loader: () => ({
                            helpPage: Dtos.Page.Committees
                        }) 
                    },
                    {
                        path: "create",
                        element: <CommitteePage />,
                        loader: () => ({
                            helpPage: Dtos.Page.Committee
                        }) 
                    },
                    {
                        path: ":committeeId",
                        loader: () => ({
                            helpPage: null
                        }),
                        children: [
                            {
                                index: true,
                                element: <Navigate replace to="details" />,
                                loader: () => ({
                                    helpPage: null
                                }) 
                            },
                            {
                                path: "details",
                                element: <CommitteePage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.Committee
                                }) 
                            },
                            {
                                path: "meetings",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <CommitteeMeetingsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.CommitteeMeetings
                                        }) 
                                    },
                                    {
                                        path: "create",
                                        element: <CommitteeMeetingPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.CommitteeMeeting
                                        }) 
                                    },
                                    {
                                        path: ":committeeMeetingId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <Navigate replace to="details" />
                                                ),
                                                loader: () => ({
                                                    helpPage: null
                                                }) 
                                            },
                                            {
                                                path: "details",
                                                element: (
                                                    <CommitteeMeetingPage />
                                                ),
                                                loader: () => ({
                                                    helpPage: Dtos.Page.CommitteeMeeting
                                                }) 
                                            },
                                            {
                                                path: "attendances",
                                                loader: () => ({
                                                    helpPage: null
                                                }),
                                                children: [
                                                    {
                                                        index: true,
                                                        element: (
                                                            <CommitteeMeetingAttendancesPage />
                                                        ),
                                                        loader: () => ({
                                                            helpPage: Dtos.Page.CommitteeMeetingAttendances
                                                        }) 
                                                    },
                                                    {
                                                        path: "create",
                                                        element: (
                                                            <CommitteeMeetingAttendancePage />
                                                        ),
                                                        loader: () => ({
                                                            helpPage: Dtos.Page.CommitteeMeetingAttendance
                                                        }) 
                                                    },
                                                    {
                                                        path: ":committeeMeetingAttendanceId",
                                                        loader: () => ({
                                                            helpPage: null
                                                        }),
                                                        children: [
                                                            {
                                                                index: true,
                                                                element: (
                                                                    <Navigate replace to="details" />
                                                                ),
                                                                loader: () => ({
                                                                    helpPage: null
                                                                }) 
                                                            },
                                                            {
                                                                path: "details",
                                                                element: (
                                                                    <CommitteeMeetingAttendancePage />
                                                                ),
                                                                loader: () => ({
                                                                    helpPage: Dtos.Page.CommitteeMeetingAttendance
                                                                }) 
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "members",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <CommitteeMembersPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.CommitteeMembers
                                        }) 
                                    },
                                    {
                                        path: "create",
                                        element: <CommitteeMemberPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.CommitteeMember
                                        }) 
                                    },
                                    {
                                        path: ":committeeMemberId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <Navigate replace to="details" />
                                                ),
                                                loader: () => ({
                                                    helpPage: null
                                                }) 
                                            },
                                            {
                                                path: "details",
                                                element: (
                                                    <CommitteeMemberPage />
                                                ),
                                                loader: () => ({
                                                    helpPage: Dtos.Page.CommitteeMember
                                                }) 
                                            },
                                            {
                                                path: "roles",
                                                loader: () => ({
                                                    helpPage: null
                                                }),
                                                children: [
                                                    {
                                                        index: true,
                                                        element: (
                                                            <CommitteeMemberRolesPage />
                                                        ),
                                                        loader: () => ({
                                                            helpPage: Dtos.Page.CommitteeMemberRoles
                                                        }) 
                                                    },
                                                    {
                                                        path: "create",
                                                        element: (
                                                            <CommitteeMemberRolePage />
                                                        ),
                                                        loader: () => ({
                                                            helpPage: Dtos.Page.CommitteeMemberRole
                                                        }) 
                                                    },
                                                    {
                                                        path: ":committeeMemberRoleId",
                                                        loader: () => ({
                                                            helpPage: null
                                                        }),
                                                        children: [
                                                            {
                                                                index: true,
                                                                element: (
                                                                    <Navigate replace to="details" />
                                                                ),
                                                                loader: () => ({
                                                                    helpPage: null
                                                                }) 
                                                            },
                                                            {
                                                                path: "details",
                                                                element: (
                                                                    <CommitteeMemberRolePage />
                                                                ),
                                                                loader: () => ({
                                                                    helpPage: Dtos.Page.CommitteeMemberRole
                                                                }) 
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "regularinvitees",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: (
                                            <CommitteeRegularInviteesPage />
                                        ),
                                        loader: () => ({
                                            helpPage: Dtos.Page.CommitteeRegularInvitees
                                        }) 
                                    },
                                    {
                                        path: "create",
                                        element: (
                                            <CommitteeRegularInviteePage />
                                        ),
                                        loader: () => ({
                                            helpPage: Dtos.Page.CommitteeRegularInvitee
                                        }) 
                                    },
                                    {
                                        path: ":committeeRegularInviteeId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <Navigate replace to="details" />
                                                ),
                                                loader: () => ({
                                                    helpPage: null
                                                }) 
                                            },
                                            {
                                                path: "details",
                                                element: (
                                                    <CommitteeRegularInviteePage />
                                                ),
                                                loader: () => ({
                                                    helpPage: Dtos.Page.CommitteeRegularInvitee
                                                }) 
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                path: "groups",
                loader: () => ({
                    helpPage: null
                }),
                children: [
                    {
                        index: true,
                        element: <GroupsPage />,
                        loader: () => ({
                            helpPage: Dtos.Page.Groups
                        }) 
                    },
                    {
                        path: "create",
                        element: <GroupPage />,
                        loader: () => ({
                            helpPage: Dtos.Page.Group
                        }) 
                    },
                    {
                        path: ":groupId",
                        loader: () => ({
                            helpPage: null
                        }),
                        children: [
                            {
                                index: true,
                                element: <Navigate replace to="details" />,
                                loader: () => ({
                                    helpPage: null
                                }) 
                            },
                            {
                                path: "details",
                                element: <GroupPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.Group
                                }) 
                            },
                            {
                                path: "trials",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <GroupTrialsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.GroupTrials
                                        }) 
                                    },
                                    {
                                        path: ":trialId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                path: "trialgroup",
                                                loader: () => ({
                                                    helpPage: null
                                                }),
                                                children: [
                                                    {
                                                        path: ":trialGroupId",
                                                        loader: () => ({
                                                            helpPage: Dtos.Page.Dashboard
                                                        }),
                                                        children: [
                                                            {
                                                                index: true,
                                                                element: (
                                                                    <Navigate replace to="details" />
                                                                ),
                                                                loader: () => ({
                                                                    helpPage: null
                                                                }) 
                                                            },
                                                            {
                                                                path: "details",
                                                                element: (
                                                                    <TrialGroupPage />
                                                                ),
                                                                loader: () => ({
                                                                    helpPage: Dtos.Page.TrialGroup
                                                                }) 
                                                            },
                                                            {
                                                                path: "personnel",
                                                                loader: () => ({
                                                                    helpPage: null
                                                                }),
                                                                children: [
                                                                    {
                                                                        index: true,
                                                                        element:
                                                                            (
                                                                                <TrialGroupPersonnelsPage />
                                                                            ),
                                                                        loader: () => ({
                                                                            helpPage: Dtos.Page.TrialGroupPersonnels
                                                                        }) 
                                                                    },
                                                                    {
                                                                        path: "create",
                                                                        element:
                                                                            (
                                                                                <TrialGroupPersonnelPage />
                                                                            ),
                                                                        loader: () => ({
                                                                            helpPage: Dtos.Page.TrialGroupPersonnel
                                                                        }) 
                                                                    },
                                                                    {
                                                                        path: ":trialPersonnelId",
                                                                        loader: () => ({
                                                                            helpPage: null
                                                                        }),
                                                                        children:
                                                                            [
                                                                                {
                                                                                    index: true,
                                                                                    element:
                                                                                        (
                                                                                            <Navigate replace to="details" />
                                                                                        ),
                                                                                        loader: () => ({
                                                                                            helpPage: null
                                                                                        }) 
                                                                                },
                                                                                {
                                                                                    path: "details",
                                                                                    element:
                                                                                        (
                                                                                            <TrialGroupPersonnelPage />
                                                                                        ),
                                                                                    loader: () => ({
                                                                                        helpPage: Dtos.Page.TrialGroupPersonnel
                                                                                    }) 
                                                                                },
                                                                            ],
                                                                    },
                                                                ],
                                                            },
                                                            {
                                                                path: "items",
                                                                element: (
                                                                    <TrialGroupItemsPage />
                                                                ),
                                                                loader: () => ({
                                                                    helpPage: Dtos.Page.TrialGroupItems
                                                                }) 
                                                            },
                                                            {
                                                                path: "labs",
                                                                loader: () => ({
                                                                    helpPage: null
                                                                }),
                                                                children: [
                                                                    {
                                                                        index: true,
                                                                        element:
                                                                            (
                                                                                <TrialGroupLaboratoriesPage />
                                                                            ),
                                                                        loader: () => ({
                                                                            helpPage: Dtos.Page.TrialGroupLaboratories
                                                                        }) 
                                                                    },
                                                                    {
                                                                        path: "create",
                                                                        element:
                                                                            (
                                                                                <TrialGroupLaboratoryPage />
                                                                            ),
                                                                        loader: () => ({
                                                                            helpPage: Dtos.Page.TrialGroupLaboratory
                                                                        }) 
                                                                    },
                                                                    {
                                                                        path: ":trialGroupLaboratoryId",
                                                                        loader: () => ({
                                                                            helpPage: null
                                                                        }),
                                                                        children:
                                                                            [
                                                                                {
                                                                                    index: true,
                                                                                    element:
                                                                                        (
                                                                                            <Navigate replace to="details" />
                                                                                        ),
                                                                                        loader: () => ({
                                                                                            helpPage: null
                                                                                        }) 
                                                                                },
                                                                                {
                                                                                    path: "details",
                                                                                    element:
                                                                                        (
                                                                                            <TrialGroupLaboratoryPage />
                                                                                        ),
                                                                                    loader: () => ({
                                                                                        helpPage: Dtos.Page.TrialGroupLaboratory
                                                                                    }) 
                                                                                },
                                                                                {
                                                                                    path: "personnel",
                                                                                    loader: () => ({
                                                                                        helpPage: null
                                                                                    }),
                                                                                    children:
                                                                                        [
                                                                                            {
                                                                                                index: true,
                                                                                                element:
                                                                                                    (
                                                                                                        <TrialGroupLaboratoryPersonnelsPage />
                                                                                                    ),
                                                                                                loader: () => ({
                                                                                                    helpPage: Dtos.Page.TrialGroupLaboratoryPersonnels
                                                                                                }) 
                                                                                            },
                                                                                            {
                                                                                                path: "create",
                                                                                                element:
                                                                                                    (
                                                                                                        <TrialGroupLaboratoryPersonnelPage />
                                                                                                    ),
                                                                                                loader: () => ({
                                                                                                    helpPage: Dtos.Page.TrialGroupLaboratoryPersonnel
                                                                                                }) 
                                                                                            },
                                                                                            {
                                                                                                path: ":trialGroupLaboratoryPersonnelId",
                                                                                                loader: () => ({
                                                                                                    helpPage: null
                                                                                                }),
                                                                                                children:
                                                                                                    [
                                                                                                        {
                                                                                                            index: true,
                                                                                                            element:
                                                                                                                (
                                                                                                                    <Navigate replace to="details" />
                                                                                                                ),
                                                                                                                loader: () => ({
                                                                                                                    helpPage: null
                                                                                                                }) 
                                                                                                        },
                                                                                                        {
                                                                                                            path: "details",
                                                                                                            element:
                                                                                                                (
                                                                                                                    <TrialGroupLaboratoryPersonnelPage />
                                                                                                                ),
                                                                                                            loader: () => ({
                                                                                                                helpPage: Dtos.Page.TrialGroupLaboratoryPersonnel
                                                                                                            }) 
                                                                                                        },
                                                                                                    ],
                                                                                            },
                                                                                        ],
                                                                                },
                                                                                {
                                                                                    path: "finance",
                                                                                    element:
                                                                                        (
                                                                                            <TrialGroupLaboratoryFinancePage />
                                                                                        ),
                                                                                    loader: () => ({
                                                                                        helpPage: Dtos.Page.TrialGroupLaboratoryFinance
                                                                                    }) 
                                                                                },
                                                                                {
                                                                                    path: "contracts",
                                                                                    loader: () => ({
                                                                                        helpPage: null
                                                                                    }),
                                                                                    children:
                                                                                        [
                                                                                            {
                                                                                                index: true,
                                                                                                element:
                                                                                                    (
                                                                                                        <TrialGroupLaboratoryContractsPage />
                                                                                                    ),
                                                                                                loader: () => ({
                                                                                                    helpPage: Dtos.Page.TrialGroupLaboratoryContracts
                                                                                                }) 
                                                                                            },
                                                                                            {
                                                                                                path: "create",
                                                                                                element:
                                                                                                    (
                                                                                                        <TrialGroupLaboratoryContractPage />
                                                                                                    ),
                                                                                                loader: () => ({
                                                                                                    helpPage: Dtos.Page.TrialGroupLaboratoryContract
                                                                                                }) 
                                                                                            },
                                                                                            {
                                                                                                path: ":trialGroupLaboratoryContractId",
                                                                                                loader: () => ({
                                                                                                    helpPage: null
                                                                                                }),
                                                                                                children:
                                                                                                    [
                                                                                                        {
                                                                                                            index: true,
                                                                                                            element:
                                                                                                                (
                                                                                                                    <Navigate replace to="details" />
                                                                                                                ),
                                                                                                                loader: () => ({
                                                                                                                    helpPage: null
                                                                                                                }) 
                                                                                                        },
                                                                                                        {
                                                                                                            path: "details",
                                                                                                            element:
                                                                                                                (
                                                                                                                    <TrialGroupLaboratoryContractPage />
                                                                                                                ),
                                                                                                            loader: () => ({
                                                                                                                helpPage: Dtos.Page.TrialGroupLaboratoryContract
                                                                                                            }) 
                                                                                                        },
                                                                                                    ],
                                                                                            },
                                                                                        ],
                                                                                },
                                                                            ],
                                                                    },
                                                                ],
                                                            },
                                                            {
                                                                path: "finance",
                                                                element: (
                                                                    <TrialGroupFinancePage />
                                                                ),
                                                                loader: () => ({
                                                                    helpPage: Dtos.Page.TrialGroupFinance
                                                                }) 
                                                            },
                                                            {
                                                                path: "contracts",
                                                                loader: () => ({
                                                                    helpPage: null
                                                                }),
                                                                children: [
                                                                    {
                                                                        index: true,
                                                                        element:
                                                                            (
                                                                                <TrialGroupContractsPage />
                                                                            ),
                                                                        loader: () => ({
                                                                            helpPage: Dtos.Page.TrialGroupContracts
                                                                        }) 
                                                                    },
                                                                    {
                                                                        path: "create",
                                                                        element:
                                                                            (
                                                                                <TrialGroupContractPage />
                                                                            ),
                                                                        loader: () => ({
                                                                            helpPage: Dtos.Page.TrialGroupContract
                                                                        }) 
                                                                    },
                                                                    {
                                                                        path: ":trialGroupContractId",
                                                                        loader: () => ({
                                                                            helpPage: null
                                                                        }),
                                                                        children:
                                                                            [
                                                                                {
                                                                                    index: true,
                                                                                    element:
                                                                                        (
                                                                                            <Navigate replace to="details" />
                                                                                        ),
                                                                                        loader: () => ({
                                                                                            helpPage: null
                                                                                        }) 
                                                                                },
                                                                                {
                                                                                    path: "details",
                                                                                    element:
                                                                                        (
                                                                                            <TrialGroupContractPage />
                                                                                        ),
                                                                                    loader: () => ({
                                                                                        helpPage: Dtos.Page.TrialGroupContract
                                                                                    }) 
                                                                                },
                                                                            ],
                                                                    },
                                                                ],
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "notes",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <GroupNotesPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.GroupNotes
                                        }) 
                                    },
                                    {
                                        path: "create",
                                        element: <NotePage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.Note
                                        }) 
                                    },
                                    {
                                        path: ":noteId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <Navigate replace to="details" />
                                                ),
                                                loader: () => ({
                                                    helpPage: null
                                                }) 
                                            },
                                            {
                                                path: "details",
                                                element: <NotePage />,
                                                loader: () => ({
                                                    helpPage: Dtos.Page.Note
                                                }) 
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "personnel",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <GroupPersonnelsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.GroupPersonnels
                                        }) 
                                    },
                                    {
                                        path: "create",
                                        element: <GroupPersonnelPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.GroupPersonnel
                                        }) 
                                    },
                                    {
                                        path: ":trialPersonnelId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <Navigate replace to="details" />
                                                ),
                                                loader: () => ({
                                                    helpPage: null
                                                }) 
                                            },
                                            {
                                                path: "details",
                                                element: <GroupPersonnelPage />,
                                                loader: () => ({
                                                    helpPage: Dtos.Page.GroupPersonnel
                                                }) 
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "contracts",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <GroupContractPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.GroupContract
                                        }) 
                                    },
                                ],
                            },
                            {
                                path: "finances",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <GroupFinancePage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.GroupFinance
                                        }) 
                                    },
                                ],
                            },
                            {
                                path: "items",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <GroupItemsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.GroupItems
                                        }) 
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                path: "personnel",
                loader: () => ({
                    helpPage: null
                }), 
                children: [
                    {
                        index: true,
                        element: <PersonnelsPage />,
                        loader: () => ({
                            helpPage: Dtos.Page.Personnels
                        }) 
                    },
                    {
                        path: "create",
                        element: <PersonnelPage />,
                        loader: () => ({
                            helpPage: Dtos.Page.Personnel
                        }) 
                    },
                    {
                        path: "byroles",
                        element: <PersonnelByRolesPage />,
                        loader: () => ({
                            helpPage: Dtos.Page.PersonnelByRoles
                        }) 
                    },
                    {
                        path: ":personnelId",
                        loader: () => ({
                            helpPage: null
                        }),
                        children: [
                            {
                                index: true,
                                element: <Navigate replace to="details" />,
                                loader: () => ({
                                    helpPage: null
                                }) 
                            },
                            {
                                path: "details",
                                element: <PersonnelPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.Personnel
                                }) 
                            },
                            {
                                path: "trainingcertifications",
                                element: <PersonnelTrainingCertificationPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.PersonnelTrainingCertification
                                }) 
                            },
                            {
                                path: "roles",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <PersonnelRolesPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.PersonnelRoles
                                        }) 
                                    },
                                    {
                                        path: "create",
                                        element: <PersonnelRolePage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.PersonnelRole
                                        }) 
                                    },
                                    {
                                        path: ":personnelRoleId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <Navigate replace to="details" />
                                                ),
                                                loader: () => ({
                                                    helpPage: null
                                                }) 
                                            },
                                            {
                                                path: "details",
                                                element: <PersonnelRolePage />,
                                                loader: () => ({
                                                    helpPage: Dtos.Page.PersonnelRole
                                                }) 
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "permissions",
                                element: <PersonnelPermissionsPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.PersonnelPermissions
                                }) 
                            },
                            {
                                path: "openclinica",
                                element: <PersonnelOCRolesPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.PersonnelOCRoles
                                }) 
                            },
                            {
                                path: "activedirectory",
                                element: <PersonnelActiveDirectoryPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.PersonnelActiveDirectory
                                }) 
                            },
                            {
                                path: "notes",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <PersonnelNotesPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.PersonnelNotes
                                        }) 
                                    },
                                    {
                                        path: "create",
                                        element: <NotePage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.Note
                                        }) 
                                    },
                                    {
                                        path: ":noteId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <Navigate replace to="details" />
                                                ),
                                                loader: () => ({
                                                    helpPage: null
                                                }) 
                                            },
                                            {
                                                path: "details",
                                                element: <NotePage />,
                                                loader: () => ({
                                                    helpPage: Dtos.Page.Note
                                                }) 
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "fellowship",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <FellowshipsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.Fellowships
                                        }) 
                                    },
                                    {
                                        path: "create",
                                        element: <FellowshipPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.Fellowship
                                        }) 
                                    },
                                    {
                                        path: ":fellowshipId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <Navigate replace to="details" />
                                                ),
                                                loader: () => ({
                                                    helpPage: null
                                                }) 
                                            },
                                            {
                                                path: "details",
                                                element: <FellowshipPage />,
                                                loader: () => ({
                                                    helpPage: Dtos.Page.Fellowship
                                                }) 
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                path: "projects",
                loader: () => ({
                    helpPage: null
                }),
                children: [
                    {
                        index: true,
                        element: <ProjectsPage />,
                        loader: () => ({
                            helpPage: Dtos.Page.Projects
                        }) 
                    },
                    {
                        path: "create",
                        element: <ProjectPage />,
                        loader: () => ({
                            helpPage: Dtos.Page.Project
                        }) 
                    },
                    {
                        path: ":projectId",
                        loader: () => ({
                            helpPage: null
                        }),
                        children: [
                            {
                                index: true,
                                element: <Navigate replace to="details" />,
                                loader: () => ({
                                    helpPage: null
                                }) 
                            },
                            {
                                path: "details",
                                element: <ProjectPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.Project
                                }) 
                            },
                            {
                                path: "items",
                                element: <ProjectItemsPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.ProjectItems
                                }) 
                            },
                            {
                                path: "investigators",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        path: "create",
                                        element: <ProjectInvestigatorPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.ProjectInvestigator
                                        }) 
                                    },
                                    {
                                        path: ":projectInvestigatorId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <Navigate replace to="details" />
                                                ),
                                                loader: () => ({
                                                    helpPage: null
                                                }) 
                                            },
                                            {
                                                path: "details",
                                                element: (
                                                    <ProjectInvestigatorPage />
                                                ),
                                                loader: () => ({
                                                    helpPage: Dtos.Page.ProjectInvestigator
                                                }) 
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "discussions",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <DiscussionsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.Discussions
                                        }) 
                                    },
                                    {
                                        path: "create",
                                        element: <DiscussionPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.Discussion
                                        }) 
                                    },
                                    {
                                        path: ":discussionId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <Navigate replace to="details" />
                                                ),
                                                loader: () => ({
                                                    helpPage: null
                                                }) 
                                            },
                                            {
                                                path: "details",
                                                element: <DiscussionPage />,
                                                loader: () => ({
                                                    helpPage: Dtos.Page.Discussion
                                                }) 
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                path: "institutions",
                loader: () => ({
                    helpPage: null
                }),
                children: [
                    {
                        index: true,
                        element: <InstitutionsPage />,
                        loader: () => ({
                            helpPage: Dtos.Page.Institutions
                        }) 
                    },
                    {
                        path: "create",
                        element: <InstitutionPage />,
                        loader: () => ({
                            helpPage: Dtos.Page.Institution
                        }) 
                    },
                    {
                        path: ":institutionId",
                        loader: () => ({
                            helpPage: null
                        }),
                        children: [
                            {
                                index: true,
                                element: <Navigate replace to="details" />,
                                loader: () => ({
                                    helpPage: null
                                }) 
                            },
                            {
                                path: "details",
                                element: <InstitutionPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.Institution
                                }) 
                            },
                            {
                                path: "departments",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <InstitutionDepartmentsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.InstitutionDepartments
                                        }) 
                                    },
                                    {
                                        path: ":departmentId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <InstitutionDepartmentEditPage />
                                                ),
                                                loader: () => ({
                                                    helpPage: Dtos.Page.InstitutionDepartmentEdit
                                                }) 
                                            },
                                            {
                                                path: "contacts",
                                                loader: () => ({
                                                    helpPage: null
                                                }),
                                                children: [
                                                    {
                                                        path: ":departmentContactId",
                                                        element: (
                                                            <InstitutionDepartmentContactEditPage />
                                                        ),
                                                        loader: () => ({
                                                            helpPage: Dtos.Page.InstitutionDepartmentContactEdit
                                                        }) 
                                                    },
                                                ],
                                            },
                                            {
                                                path: "personnel",
                                                loader: () => ({
                                                    helpPage: null
                                                }),
                                                children: [
                                                    {
                                                        path: ":personnelRoleId",
                                                        element: (
                                                            <InstitutionDepartmentPersonnelEditPage />
                                                        ),
                                                        loader: () => ({
                                                            helpPage: Dtos.Page.InstitutionDepartmentPersonnelEdit
                                                        }) 
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "institutionitems",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <InstitutionItemsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.InstitutionItems
                                        }) 
                                    },
                                ],
                            },
                            {
                                path: "personnel",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <InstitutionPersonnelsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.InstitutionPersonnels
                                        }) 
                                    },
                                    {
                                        path: "create",
                                        element: <InstitutionPersonnelPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.InstitutionPersonnel
                                        }) 
                                    },
                                    {
                                        path: ":trialPersonnelId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <Navigate replace to="details" />
                                                ),
                                                loader: () => ({
                                                    helpPage: null
                                                }) 
                                            },
                                            {
                                                path: "details",
                                                element: (
                                                    <InstitutionPersonnelPage />
                                                ),
                                                loader: () => ({
                                                    helpPage: Dtos.Page.InstitutionPersonnel
                                                }) 
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "labs",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: (
                                            <InstitutionLaboratoriesPage />
                                        ),
                                        loader: () => ({
                                            helpPage: Dtos.Page.InstitutionLaboratories
                                        }) 
                                    },
                                    {
                                        path: "create",
                                        element: <InstitutionLaboratoryPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.InstitutionLaboratory
                                        }) 
                                    },
                                    {
                                        path: ":institutionLaboratoryId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <Navigate replace to="details" />
                                                ),
                                                loader: () => ({
                                                    helpPage: null
                                                }) 
                                            },
                                            {
                                                path: "details",
                                                element: (
                                                    <InstitutionLaboratoryPage />
                                                ),
                                                loader: () => ({
                                                    helpPage: Dtos.Page.InstitutionLaboratory
                                                }) 
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "notes",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <InstitutionNotesPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.InstitutionNotes
                                        }) 
                                    },
                                    {
                                        path: "create",
                                        element: <NotePage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.Note
                                        }) 
                                    },
                                    {
                                        path: ":noteId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <Navigate replace to="details" />
                                                ),
                                                loader: () => ({
                                                    helpPage: null
                                                }) 
                                            },
                                            {
                                                path: "details",
                                                element: <NotePage />,
                                                loader: () => ({
                                                    helpPage: Dtos.Page.Note
                                                }) 
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "procedures",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <InstitutionProceduresPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.InstitutionProcedures
                                        }) 
                                    },
                                    {
                                        path: "create",
                                        element: <InstitutionProcedurePage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.InstitutionProcedure
                                        }) 
                                    },
                                    {
                                        path: ":institutionProcedureId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <Navigate replace to="details" />
                                                ),
                                                loader: () => ({
                                                    helpPage: null
                                                }) 
                                            },
                                            {
                                                path: "details",
                                                element: (
                                                    <InstitutionProcedurePage />
                                                ),
                                                loader: () => ({
                                                    helpPage: Dtos.Page.InstitutionProcedure
                                                }) 
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "finance",
                                element: <InstitutionFinancePage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.InstitutionFinance
                                }) 
                            },
                            {
                                path: "contract",
                                element: <InstitutionContractPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.InstitutionContract
                                }) 
                            },
                            {
                                path: "codes",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <InstitutionCodesPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.InstitutionCodes
                                        }) 
                                    },
                                    {
                                        path: "create",
                                        element: <InstitutionCodePage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.InstitutionCode
                                        }) 
                                    },
                                    {
                                        path: ":institutionCodeId",
                                        loader: () => ({
                                            helpPage: Dtos.Page.Dashboard
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: <Navigate replace to="details" />,
                                                loader: () => ({
                                                    helpPage: null
                                                }) 
                                            },
                                            {
                                                path: "details",
                                                element: <InstitutionCodePage />,
                                                loader: () => ({
                                                    helpPage: Dtos.Page.InstitutionCode
                                                }) 
                                            }
                                        ],
                                    },
                                ]
                            },
                            {
                                path: "trials",
                                element: <InstitutionTrialsPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.InstitutionTrials
                                }) 
                            }
                        ],
                    },
                ],
            },
            {
                path: "labs",
                loader: () => ({
                    helpPage: null
                }),
                children: [
                    {
                        index: true,
                        element: <LabsPage />,
                        loader: () => ({
                            helpPage: Dtos.Page.Labs
                        }) 
                    },
                    {
                        path: "create",
                        element: <LabPage />,
                        loader: () => ({
                            helpPage: Dtos.Page.Lab
                        }) 
                    },
                    {
                        path: ":laboratoryId",
                        loader: () => ({
                            helpPage: null
                        }),
                        children: [
                            {
                                index: true,
                                element: <Navigate replace to="details" />,
                                loader: () => ({
                                    helpPage: null
                                }) 
                            },
                            {
                                path: "details",
                                element: <LabPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.Lab
                                }) 
                            },
                            {
                                path: "departments",
                                loader: () => ({
                                    helpPage: Dtos.Page.Dashboard
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <LabDepartmentsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.LabDepartments
                                        }) 
                                    },
                                    {
                                        path: "create",
                                        element: <LabDepartmentPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.LabDepartment
                                        }) 
                                    },
                                    {
                                        path: ":laboratoryDepartmentId",
                                        loader: () => ({
                                            helpPage: null
                                        }), 
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <Navigate replace to="details" />
                                                ),
                                                loader: () => ({
                                                    helpPage: null
                                                }) 
                                            },
                                            {
                                                path: "details",
                                                element: <LabDepartmentPage />,
                                                loader: () => ({
                                                    helpPage: Dtos.Page.LabDepartment
                                                }) 
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "personnel",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <LabPersonnelsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.LabPersonnels
                                        }) 
                                    },
                                    {
                                        path: "create",
                                        element: <LabPersonnelPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.LabPersonnel
                                        }) 
                                    },
                                    {
                                        path: ":laboratoryPersonnelId",
                                        loader: () => ({
                                            helpPage: null
                                        }), 
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <Navigate replace to="details" />
                                                ),
                                                loader: () => ({
                                                    helpPage: null
                                                }) 
                                            },
                                            {
                                                path: "details",
                                                element: <LabPersonnelPage />,
                                                loader: () => ({
                                                    helpPage: Dtos.Page.LabPersonnel
                                                }) 
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "institutions",
                                loader: () => ({
                                    helpPage: null
                                }),
                                children: [
                                    {
                                        index: true,
                                        element: <LabInstitutionsPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.LabInstitutions
                                        }) 
                                    },
                                    {
                                        path: "create",
                                        element: <LabInstitutionPage />,
                                        loader: () => ({
                                            helpPage: Dtos.Page.LabInstitution
                                        }) 
                                    },
                                    {
                                        path: ":institutionLaboratoryId",
                                        loader: () => ({
                                            helpPage: null
                                        }),
                                        children: [
                                            {
                                                index: true,
                                                element: (
                                                    <Navigate replace to="details" />
                                                ),
                                                loader: () => ({
                                                    helpPage: null
                                                }) 
                                            },
                                            {
                                                path: "details",
                                                element: <LabInstitutionPage />,
                                                loader: () => ({
                                                    helpPage: Dtos.Page.LabInstitutions
                                                }) 
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                path: "finance",
                                element: <LabFinancePage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.LabFinance
                                }) 
                            },
                            {
                                path: "contract",
                                element: <LabContractPage />,
                                loader: () => ({
                                    helpPage: Dtos.Page.LabContract
                                }) 
                            },
                        ],
                    },
                ],
            },
        ],
    },
];

const router = createBrowserRouter(routes as any);

interface IAppActions {
    loadUser?: UserActions.IUserLoadActionCreator;
    navigate?: Function;
}

interface IAppProps {
    user?: Dtos.User;
    loadingUser?: boolean;
    loadUserSuccess?: boolean;
    loadUserFailure?: boolean;

    checkedAuthentication?: boolean;
}

type AppProps = IAppProps & IAppActions;

export default class App extends React.Component<AppProps, any> {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { user, loadUser, loadingUser } = this.props;

        if (!user && loadUser && !loadingUser) {
            loadUser();
        }
    }

    render() {
        const { user, checkedAuthentication } = this.props;

        if (!checkedAuthentication || !AppSettings) {
            return <OverlayLoading />;
        } else if (!user) {
            window.location.href =
                "/auth/openiddict?ReturnUrl=" +
                encodeURIComponent(
                    window.location.pathname + window.location.search
                );
            return <OverlayLoading />;
        }

        return (
            <div>
                <RouterProvider router={router} />
                <Alert
                    stack={{ limit: 5 }}
                    html={false}
                    effect="scale"
                    position="bottom-right"
                    timeout={5000}
                />
            </div>
        );
    }
}

const mapStateToProps = (state: ITmdState, _ownProps: AppProps): IAppProps => {
    return {
        user: state.user.data,
        loadingUser:
            state.user.loadState &&
            state.user.loadState.status == RequestState.Pending,
        loadUserSuccess:
            state.user.loadState &&
            state.user.loadState.status == RequestState.Success,
        loadUserFailure:
            state.user.loadState &&
            state.user.loadState.status == RequestState.Failure,
        checkedAuthentication: state.user.checked,
    };
};

const mapDispatchToProps = (dispatch): IAppActions => {
    return {
        loadUser: bindActionCreators(UserActions.LoadUser, dispatch),
        navigate: bindActionCreators(routerActions.push, dispatch),
    };
};

const ConnectedApp = connect(mapStateToProps, mapDispatchToProps)(App);

ReactDOM.render(
    <ReduxContext.Provider value={store as any}>
        <Provider store={store as any}>
            <ConnectedApp />
        </Provider>
    </ReduxContext.Provider>,
    document.getElementById("app")
);
